import React, { useReducer } from 'react'
import { sessionStorage } from 'react-storage'
import { useRouter, standardTubeRoute, homeRoute } from '@src/routes'
// TODO: reimplement DLC-191 post MVP for DTAQ project
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'
import CircleLoader from '@src/components/CircleLoader'
import Breadcrumb from '@src/components/Breadcrumb'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import PageHeader from '@src/routes/Configurators/components/PageHeader'
import ProductEntryTab from '@src/routes/Configurators/components/ProductEntryTab'
import SingleProductEntry from './Step1/SingleProductEntry'
import MultiProductEntry from './Step1/MultiProductEntry'
import ConfirmOrder from './Step2/ConfirmOrder'
import LeftNav from '@src/routes/Configurators/components/LeftNav'
import messages from '../../messages'
import {
  SpecificationsComponent,
  useGetProductInformationQuery,
  useGetSessionDataQuery,
  useTubeEditLinkQuery,
} from '@src/queries/ConfiguratorTubesQuery.generated'
import { useCurrentUserQuery } from '@src/queries/CurrentUserQuery.generated'
import {
  initialState,
  reducer,
  configContext,
} from '../../utils/StandardReducer'
import { useUserSession } from '@utils/useUserSession'
import { ActiveLinkType, TubeProduct, TubeProperties } from './enum'
import ReviewDialog from './Step2/ReviewDialog'
import { FormattedMessage, useIntl } from 'react-intl'
import { DialogContent } from '@material-ui/core'
import { default as UUID } from 'uuid'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { getMaxId } from '@src/routes/Configurators/utils/util'
import ConfiguratorPageError from '@src/routes/Configurators/utils/ConfiguratorPageError'
import { BreadcrumbNavigationUrls } from '@src/routes/Configurators/utils/BreadcrumbNavigationUrlsEnum'
import styles from '@src/routes/Configurators/utils/styles'
import {
  ConfiguratorProductDetails,
  ProductInformation,
  TubeEditLinkDetails,
  StandardConfiguratorAddToMiniCart,
} from '../ConfiguratorSharedTypes'
import { useGetProduct } from '../../utils/useGetProduct'

const validateActiveLink = (activeLink) => {
  return activeLink === '' || activeLink == null
    ? ActiveLinkType.SequenceEntry
    : activeLink
}

const StandardTube = () => {
  const router = useRouter()
  const intl = useIntl()
  const GlobalCSS = styles()
  const [state, dispatch] = useReducer(reducer, initialState)
  const { userSession } = useUserSession()
  const [itemDetails, setItemDetails] = React.useState<any>([])
  const countryCd = userSession.country
  const [errorMsg, setErrorMsg] = React.useState('')
  const [addItemsFromSideNav, setAddItemsFromSideNav] = React.useState(false)
  const { data, loading } = useCurrentUserQuery()
  const [open, setOpen] = React.useState(false)
  const [fetchApi, setFetchApi] = React.useState(false)
  const currentUser: any = data?.me || null
  let loggedIn
  if (!loading)
    loggedIn =
      currentUser && currentUser.__typename === TubeProperties.LoggedInUser

  let participationId: string
  let locale: string
  let isCSR: boolean
  let isCSRSupervisor: boolean
  let isSAPNextEnabled: boolean
  let isConfiguratorDisabled: boolean
  let isOrderCustomer: boolean
  let isOrderableCustomer: boolean
  let isGuestShoppingCountry: boolean
  const date = new Date()
  const timeZone = (date.getTimezoneOffset() / 60) * -1
  const cartId = router?.query?.cartid ?? ''
  const itemId = router?.query?.itemid ?? ''
  let activeLink = router?.query?.activeLink ?? ''

  const product = useGetProduct()

  let accessToken = ''
  let store = ''
  if (userSession.accessToken) {
    accessToken = userSession.accessToken
  }
  if (userSession.store) {
    store = userSession.store
  }
  if (loggedIn && currentUser) {
    participationId = currentUser.id
    locale = `${userSession.language}_${countryCd}`
    if (locale === '') {
      locale = currentUser?.metadata.locale
    }
    isCSR = currentUser?.roles.isCustomerServiceRep
    isCSRSupervisor = currentUser?.roles.isCustomProductCSR
    isSAPNextEnabled = currentUser.metadata.isSAPNextEnabled
    isGuestShoppingCountry = currentUser.metadata.guestShoppingType
    isOrderCustomer =
      currentUser?.roles.isPublicOrderingCustomer ||
      currentUser?.roles.isQuoteRequester
    if (isGuestShoppingCountry !== null) {
      isOrderableCustomer = true
    } else if (isOrderCustomer && isGuestShoppingCountry === null) {
      isOrderableCustomer = true
    } else {
      isOrderableCustomer = false
    }
    isConfiguratorDisabled =
      currentUser.participantSitePreference?.hideOligoPeptideDesign
  } else if (userSession.accessToken) {
    participationId = userSession.accessToken
    locale = `${userSession.language}_${countryCd}`
    isCSR = false
    isCSRSupervisor = false
    isOrderableCustomer = false
    isSAPNextEnabled = currentUser?.metadata.isSAPNextEnabled
    isConfiguratorDisabled = false
  } else {
    //TODO: commented participationId as a part of fix for STRAT-11633
    //Identify why the page is going in an infinite loop when fetching the id dynamically.
    participationId = UUID.v4()
    locale = `en_${countryCd}`
    isCSR = false
    isCSRSupervisor = false
    isOrderableCustomer = false
    isSAPNextEnabled = true
    isConfiguratorDisabled = false
  }

  const [sessionResp, setSessionResp] = React.useState<any>([])
  const [openError, setOpenError] = React.useState<boolean>(false)

  const productDetails: ConfiguratorProductDetails = {
    productType: product,
    participantId: participationId,
    countryCode: countryCd,
    isRegUser: loggedIn,
    locale: locale,
    isCSR: isCSR,
    isCSRSupervisor: isCSRSupervisor,
    sapNextEnabled: isSAPNextEnabled,
    timeZone: timeZone.toString(),
    store: store,
  }
  const tubeEditLinkDetails: TubeEditLinkDetails = {
    productType: product,
    participantId: participationId,
    countryCode: countryCd,
    cartId: cartId,
    cartItemId: itemId,
    store: store,
  }

  const productInformation: ProductInformation = {
    productType: product,
    countryCode: countryCd,
    isCsr: isCSR,
    isCsrSupervisor: isCSRSupervisor,
    isOrderableCustomer: isOrderableCustomer,
    regUser: loggedIn,
    locale: locale,
    sapNextEnabled: isSAPNextEnabled,
    hideOligoPeptideDesign: isConfiguratorDisabled,
  }

  if (loggedIn) {
    const referrerParticipantId: string | null = sessionStorage.getItem(
      'CONFIGURATOR_REFERRER_ID'
    )
    if (referrerParticipantId) {
      productDetails.guestParticipantId = referrerParticipantId
    }
  }

  const { data: editLinkData } = useTubeEditLinkQuery({
    variables: {
      product: tubeEditLinkDetails,
    },
    fetchPolicy: 'no-cache',
    skip: !accessToken || !(cartId && itemId),
    ssr: false,
  })

  const { data: sessionResponseData } = useGetSessionDataQuery({
    variables: {
      product: productDetails,
    },
    fetchPolicy: 'no-cache',
    skip: !accessToken,
    ssr: false,
  })

  React.useEffect(() => {
    let sessionResp: any
    if (cartId && itemId && editLinkData) {
      sessionResp = editLinkData?.tubeEditLink?.data
    } else {
      sessionResp = sessionResponseData?.getSessionData?.data
    }
    setFetchApi(true)
    setSessionResp(sessionResp)
  }, [editLinkData, sessionResponseData])

  const displayErrorPopUpOnReview = () => {
    if (state.isSideNavLinkDisabled) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
    } else {
      dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    }
  }

  const orderPath = `${standardTubeRoute.index()}?product=${product}&activeLink=${
    ActiveLinkType.ConfirmOrder
  }`

  const configuratorAddToMiniCart: StandardConfiguratorAddToMiniCart = {
    productType: product,
    countryCode: countryCd,
    participantId: participationId,
    locale: locale,
    sapNextEnabled: isSAPNextEnabled,
    timeZone: timeZone.toString(),
    store: store,
  }

  const sequencePath = `${standardTubeRoute.index()}?product=${product}&activeLink=${
    ActiveLinkType.SequenceEntry
  }`

  //  if productCode  is 1 i.e product is unauthorized
  //                     2 i.e product is invalid
  //                     0 i.e product is valid
  const [productCode, setProductCode] = React.useState(0)
  const [isApiCall, setIsApiCall] = React.useState(true)
  let apiData: any = {}
  const FetchProductDetails = async (obj) => {
    const { data, loading } = useGetProductInformationQuery({
      variables: {
        input: obj,
      },
      fetchPolicy: 'no-cache',
    })
    if (!loading && loggedIn !== undefined) {
      apiData = data?.getProductInformation
    }
  }

  React.useEffect(() => {
    if (Object.keys(apiData).length !== 0 && isApiCall) {
      setIsApiCall(false)
      const {
        productType,
        shippingOptions,
        brand,
        companionProducts,
        instructions,
        displayName,
        packageType,
        typeCode,
        currencyFormat,
        decimalSeparator,
        thousandSeparator,
        prefixCurrecny,
        thousandSpacing,
      } = apiData

      if (displayName === TubeProperties.UnAuthorized) {
        setProductCode(1)
      } else if (displayName.includes(TubeProperties.InvalidProduct)) {
        setProductCode(2)
      } else if (displayName.includes(TubeProperties.ProductNotValid)) {
        setProductCode(3)
      } else if (displayName.includes(TubeProperties.UserCannotOrder)) {
        setProductCode(4)
      } else {
        setProductCode(0)
        const productData = {
          productType: productType,
          shippingOptions: shippingOptions,
          brand: brand,
          companionProducts: companionProducts,
          instructions: instructions,
          packageType: packageType,
          typeCode: typeCode,
          currencyFormat: currencyFormat,
          decimalSeparator: decimalSeparator,
          thousandSeparator: thousandSeparator,
          prefixCurrecny: prefixCurrecny,
          thousandSpacing: thousandSpacing,
        }
        dispatch({
          type: 'SET_PRODUCT_INFORMATION',
          data: productData,
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [apiData])

  accessToken && FetchProductDetails(productInformation)

  React.useEffect(() => {
    if (sessionResp && fetchApi) {
      if (sessionResp.length !== 0) {
        sessionResp.forEach((item) => {
          delete item.__typename
        })

        if (sessionResp[0].name !== '' || sessionResp[0].sequence !== '') {
          dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: true })
        }
        dispatch({
          type: 'COUNTRY_CODE',
          data: countryCd,
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: sessionResp,
        })
        const maxId = getMaxId(sessionResp)
        dispatch({
          type: 'ADD_NEW_OLIGO',
          data: maxId,
        })

        dispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: sessionResp.length - 1,
        })
        dispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: sessionResp.length - 1,
        })
        dispatch({
          type: 'UPDATE_PAGE_LOAD',
          data: 1,
        })
        dispatch({
          type: 'IS_SESSION_DATA_RETRIEVED',
          data: true,
        })
        if (
          activeLink === ActiveLinkType.ReviewPage &&
          sessionResp.length === 1 &&
          sessionResp[0].name === '' &&
          sessionResp[0].sequence === ''
        ) {
          router.push(sequencePath)
        }
      } else {
        dispatch({
          type: 'IS_SESSION_DATA_RETRIEVED',
          data: true,
        })
        dispatch({
          type: 'UPDATE_PAGE_LOAD',
          data: 3,
        })
        if (activeLink === ActiveLinkType.ReviewPage) {
          router.push(sequencePath)
        }
      }
      if (cartId && itemId) {
        router.replace(sequencePath)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [sessionResp])

  React.useEffect(() => {
    state.pageError && state.pageError.length
      ? setOpenError(true)
      : setOpenError(false)
  }, [state.pageError])
  React.useEffect(() => {
    if (state.isDisplayError) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [state.isDisplayError])

  React.useEffect(() => {
    dispatch({ type: 'INIT' })
  }, [])

  React.useEffect(() => {
    const maxItems =
      productDetails.productType === TubeProduct.iscaledna
        ? TubeProperties.MaximumOligosAllowedIscaledna
        : TubeProperties.MaximumOligosAllowed
    if (cartId && itemId) {
      dispatch({ type: 'IS_CONFIRM_ORDER', data: true })
    }
    if (
      state.pageError.includes(
        intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
      )
    ) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
    }
    if (
      router.query.activeLink === ActiveLinkType.SequenceEntry &&
      state.isComingFromConfirmPage
    ) {
      dispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: state.sessionData.length - 1,
      })

      dispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 2,
      })
      dispatch({ type: 'IS_COMING_FROM_CONFIRM_PAGE', data: false })
    }
  }, [router.query.activeLink])

  React.useEffect(() => {
    return function cleanupError() {
      !loggedIn
        ? sessionStorage.setItem(
            'CONFIGURATOR_REFERRER_ID',
            productDetails.participantId
          )
        : sessionStorage.removeItem('CONFIGURATOR_REFERRER_ID')
    }
  }, [])

  activeLink = validateActiveLink(activeLink)

  const standardTubeProductKey = `CONF_STANDARD_TUBES_${product}`
  const breadcrumbItems = [
    {
      url: homeRoute.index(),
      label: <FormattedMessage {...messages[`CONF_HOME_${product}`]} />,
    },
    {
      url: BreadcrumbNavigationUrls.BreadcrumbCustomProducts,
      label: (
        <FormattedMessage {...messages[`CONF_CUSTOM_PRODUCTS_${product}`]} />
      ),
    },
    {
      url: BreadcrumbNavigationUrls[`Breadcrumb_${product}`],
      label: (
        <FormattedMessage {...messages[`CONF_OLIGOS_PROBES_${product}`]} />
      ),
    },
    {
      url: '',
      label: (
        <FormattedMessage
          {...messages[standardTubeProductKey]}
          values={{
            registered: (
              <sup>
                <FormattedMessage {...messages.CONF_TRADEMARK} />
              </sup>
            ),
          }}
        />
      ),
    },
  ]

  const getUrlForConfirmOrder = () => {
    return orderPath
  }
  const sidebarItems = [
    {
      label: (
        <FormattedMessage {...messages[`CONF_SEQUENCE_ENTRY_${product}`]} />
      ),
      activeLink:
        activeLink === ActiveLinkType.SequenceEntry ||
        activeLink === ActiveLinkType.ReviewPage
          ? true
          : false,
      url: `${standardTubeRoute.index()}?product=${product}&activeLink=${
        ActiveLinkType.SequenceEntry
      }`,
      linkDisable: false,
      linkNotClickable: state.bulkReview,
    },
  ]

  sidebarItems.push({
    label: <FormattedMessage {...messages[`CONF_CONFIRM_ORDER_${product}`]} />,
    activeLink: activeLink === ActiveLinkType.ConfirmOrder ? true : false,
    url: getUrlForConfirmOrder(),

    linkDisable: !state.isConfirmOrder,
    linkNotClickable: !state.isConfirmOrder,
  })

  const setActive = (id) => {
    if (activeLink === ActiveLinkType.ConfirmOrder) {
      router.push(sequencePath)
    }
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: id,
    })
    dispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
  }

  const navigateToConfirm = () => {
    setErrorMsg('')
    router.push(orderPath)
  }
  const standardContentComponent = (getSpecifications) => {
    if (
      activeLink === ActiveLinkType.SequenceEntry ||
      activeLink === ActiveLinkType.MultipleEntry
    ) {
      return (
        <>
          <ErrorAlert
            open={openError}
            setOpen={setOpenError}
            message={state.pageError}
          />
          <ProductEntryTab
            singleProductEntry={
              <SingleProductEntry
                specificationsData={getSpecifications}
                productDetails={productDetails}
                productType={product}
                setErrorMsg={setErrorMsg}
                setActive={setActive}
                setAddItemsFromSideNav={setAddItemsFromSideNav}
                setItemDetails={setItemDetails}
              />
            }
            multiProductEntry={
              <MultiProductEntry
                navigateToConfirm={navigateToConfirm}
                productDetails={productDetails}
                setAddItemsFromSideNav={setAddItemsFromSideNav}
                setItemDetails={setItemDetails}
              />
            }
          />
        </>
      )
    }

    if (activeLink === ActiveLinkType.ConfirmOrder) {
      return (
        <ConfirmOrder
          productDetails={productDetails}
          configuratorAddToMiniCart={configuratorAddToMiniCart}
          itemDetails={itemDetails}
          specificationsData={getSpecifications}
        />
      )
    }

    if (activeLink === ActiveLinkType.ReviewPage) {
      setErrorMsg('')
      return (
        <ReviewDialog
          productDetails={productDetails}
          setItemDetails={setItemDetails}
        />
      )
    }

    return null
  }

  const productKey = `CONF_DNA_OLIGOS_IN_TUBES_${product}`
  return (
    <configContext.Provider value={{ state, dispatch }}>
      <SpecificationsComponent
        ssr={false}
        variables={{
          product: productDetails,
        }}
      >
        {({ loading, error, data }) => {
          if (loading) return <CircleLoader />
          if (error || !data || !data.getSpecifications) return null
          const { getSpecifications } = data

          return (
            <DefaultLayout spacing={LayoutSpacingOptions.MD}>
              {productCode !== 0 ? (
                <ConfiguratorPageError
                  productCode={productCode}
                  country={countryCd}
                />
              ) : (
                <Container>
                  <Breadcrumb items={breadcrumbItems} />
                  <PageHeader
                    label={
                      <FormattedMessage
                        {...messages[productKey]}
                        values={{
                          registered: (
                            <sup className={GlobalCSS.registeredSymbol}>
                              <FormattedMessage {...messages.CONF_TRADEMARK} />
                            </sup>
                          ),
                        }}
                      />
                    }
                  />
                  <Grid container spacing={10}>
                    <Grid item xs={3}>
                      {state.isConfirmOrder ? (
                        <LeftNav
                          sidebarItems={sidebarItems}
                          addProductsFromSideNav={addItemsFromSideNav}
                          setActive={setActive}
                          productType={product}
                          activeStep={1}
                          productDetails={productDetails}
                          isNotNavigateable={state.isSideNavLinkDisabled}
                          displayErrorPopUpOnReview={displayErrorPopUpOnReview}
                        />
                      ) : (
                        <LeftNav
                          sidebarItems={sidebarItems}
                          addProductsFromSideNav={addItemsFromSideNav}
                          setActive={setActive}
                          productType={product}
                          activeStep={0}
                          productDetails={productDetails}
                          isNotNavigateable={state.isSideNavLinkDisabled}
                        />
                      )}
                    </Grid>
                    <Grid item xs={9}>
                      {errorMsg && state.isDisplayError ? (
                        <DialogContent>
                          <ErrorAlert
                            open={open}
                            setOpen={setOpen}
                            message={errorMsg}
                          />
                        </DialogContent>
                      ) : (
                        ''
                      )}

                      <div>{standardContentComponent(getSpecifications)}</div>
                    </Grid>
                  </Grid>
                </Container>
              )}
            </DefaultLayout>
          )
        }}
      </SpecificationsComponent>
    </configContext.Provider>
  )
}

export default StandardTube
